import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=4b664e7a&scoped=true&"
import script from "./AppBar.vue?vue&type=script&lang=ts&"
export * from "./AppBar.vue?vue&type=script&lang=ts&"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=4b664e7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b664e7a",
  null
  
)

export default component.exports